import { useLocalSearchParams } from "expo-router";
import React from "react";

import PageLayout from "$src/core/components/templates/PageLayout";
import DetailPage from "$src/core/pages/DetailPage";
import isValidContentType from "$src/core/utils/dto/is-valid-content-type";

type Params = {
  id: string;
  type: string;
};

const Route: React.FC = () => {
  const { id, type } = useLocalSearchParams<Params>();

  if (!id || !isValidContentType(type)) return null;

  return (
    <PageLayout statusBarStyle="light">
      <DetailPage id={id.toString()} type={type} />
    </PageLayout>
  );
};

export default Route;
